export enum Features {
  BOOKINGS_EXCLUDE_CUSTOMERS = 'bookings.excluded-customers',
  QUOTE_REQUEST_FCL_CRD = 'ship.quote-request-fcl-crd',
  SHOW_DEFAULT_FOR_INTEGRATIONS_IN_LEGAL_ENTITY = 'cftmasterdata.showDefaultForIntegrationsInLEs',
  LOCAL_CURRENCY_DISPLAY = 'cft-booking.ship.local-currency-display',
  NEW_RATE_FILTERS = 'cft-booking.ship.new-rate-filters',
  BOOKING_ACCEPTANCE_REQUIREMENTS = 'tms.booking.acceptance-requirements',

  LOCAL_HANDLING_SERVICES = 'tms.shipments.local-handling-services',

  VGM_LOCAL_HANDLING_SERVICES = 'tms.shipments.vgm-local-handling-services',

  // FFs owned by IAM
  AUTH0_LOGIN = 'ship-v2.auth0.login',

  // FFs owned by Insights And Integrations
  DEM_DET = 'cft-insights.mot.dem_det', // Operational FF to blacklist customers from using DEM/DET
  COMPANY_ACCOUNT_PAGE = 'cft-insights.ship-v2.company-account-page', // FF to enable the company account page

  CONTEXTUAL_ADDRESS_PORT_SELECTION = 'insights-integrations.releases.contextualAddressPortSelection',

  // TEMP(FLASH-INTERIM): MoT02_EV04 carries interim Flash wording until Booking Confirmation epic is released. Remove this flag together with its only usage.
  TEMP_FLASH_BOOKING_CONFIRMATION = 'insights-integrations.releases.tempFlashBookingConfirmation',

  SHIPMENT_OVERVIEW_DEM_DET_TAB = 'cft-shipping.ship.shipment-overview-demdet_tab',
  TRANSPORT_PLAN_PORTS = 'transport-network.ports',
  TRADE_FINANCE_BANNER = 'ship.trade-finance-banner',
  INTEGRATIONS_ENABLED = 'cftcustomersintegrations.newui',
  ALLOW_SYRIA_IN_BOOKING_RESTRICTED_COUNTRIES = 'cft-booking.ship.allow-syria-in-restricted-countries',
  SUSTAINABILITY_NEW_PRODUCTS = 'cft-booking.ship.sustainability-new-products',
  SHIPMENT_IOT_TRACKING_TAB = 'cft-shipping.ship.iot-tracking',
  ENABLE_BILLING_CORE_INVOICE = 'billing.enable.billing-core.invoice',
  DOCUMENTS_V2 = 'paw.ship.documents-v2',
  SHIPMENT_TAGS = 'tms.shipment.tags',

  SHIP_V2_BETA = 'ship-v2.release.beta',
  SHIP_V2_ALLOW_SWITCH = 'ship-v2.release.allow-switch',

  // FFs owned by Pricing
  CUSTOMER_REQUESTED_QUOTES = 'pricing.ship-v2-customer-requested-quotes',

  // FFs owned by Shipping

  EDIT_GENERAL_INFORMATION = 'ship-v2.edit-general-information',
  FREE_TEXT_BOOKING = `ship-v2.free-text-booking`,

  MULTIPLE_COMMODITIES_UN_NUMBERS = 'ship-v2.container-details.multiple-commodities-un-numbers',
  NEW_CUSTOMS_SERVICE = 'tms.shipments.custom-service',
  CUSTOMER_BOOKING_CONFIRMATION = 'tms.shipments.customer-booking-confirmation',
  REQUESTED_PICKUP_DELIVERY_DATES = 'tms.booking.wizard-requested-pickup-delivery-dates',
  REQUESTED_ETD_ETA = 'tms.booking.requested-etd-eta',
  MULTIPLE_PICKUP_DELIVERY_ADDRESSES = 'tms.booking.multiple-pickup-delivery-addresses',
}
